import ResizeableCell from 'components/TableExtended/partials/ResizeableCell/ResizeableCell'

export default ResizeableCell
